import React from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
  Button,
  Grid,
} from '@material-ui/core';
import history from '../../../history';
import MemoBaseTypography from '../../Text/BaseTypography';
import { GraySmall } from '../../../theme/colors';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(3.5),
      [theme.breakpoints.down('xs')]: {
        padding: theme.spacing(2.5, 3),
      },
    },
    descriptionWrapper: {
      marginTop: theme.spacing(1.5),
      minHeight: '40px',
    },
    illustrationWrapper: {
      display: 'flex',
      justifyContent: 'end',
      [theme.breakpoints.down('sm')]: {
        display: 'none',
      },
    },
    actionButton: {
      marginTop: theme.spacing(2.75),
    },
    illustration: {
      maxWidth: 200,
      maxHeight: 160,
    },
  }),
);
interface TaskData {
  title: string;
  description: string;
  buttonLabel: string;
  path: string;
  illustrationName: string;
}

interface TaskProps {
  taskData: TaskData;
}

export const TaskDetails: React.FC<TaskProps> = ({ taskData }) => {
  const classes = useStyles();

  return (
    <Grid container className={classes.root}>
      <Grid item xs>
        <MemoBaseTypography fontType="15Medium">
          {taskData.title}
        </MemoBaseTypography>
        <div className={classes.descriptionWrapper}>
          <MemoBaseTypography style={{ color: GraySmall }} fontType="13Regular">
            {taskData.description}
          </MemoBaseTypography>
        </div>
        <Button
          className={classes.actionButton}
          variant="contained"
          color="secondary"
          onClick={() => history.push(taskData.path)}
        >
          {taskData.buttonLabel}
        </Button>
      </Grid>
      <Grid className={classes.illustrationWrapper} item xs>
        <img
          className={classes.illustration}
          src={`/images/${taskData.illustrationName}.jpg`}
          alt="Task illustration"
        />
      </Grid>
    </Grid>
  );
};
